/* eslint-disable react/prop-types */
import { Box, Modal as MUIModal } from "@mui/material";
import React from "react";
import style from "./styles";

function Modal({ open, onClose, children, customStyle, styles }) {
  return (
    <MUIModal open={open} onClose={onClose} sx={{ ...styles }}>
      <Box style={{ ...style.popup, ...customStyle }}>{children}</Box>
    </MUIModal>
  );
}

export default Modal;
